export default "__VITE_ASSET__YAZgmgod__"